import { passwordConfirmationSchema, PasswordSchema, UsernameSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const RegisterFormInputSchema = oz.object({
  username: UsernameSchema.optional(),
  password: PasswordSchema.optional(),
  confirmPassword: passwordConfirmationSchema.optional(),
});

export type RegisterFormInput = oz.infer<typeof RegisterFormInputSchema>;